<template>
  <div :class="cols">
    <label class="block mb-1 text-sm font-medium text-gray-700" :for="id">{{ label }}</label>
    <input type="date"
           :id="id"
           :name="id"
           v-model="modelValue"
           :placeholder="placeholder"
           :disabled="disabled"
           class="shadow-sm focus:ring-blue-700 focus:border-blue-700 focus:text-gray-700 placeholder-gray-400 block w-full sm:text-sm border-gray-400 rounded-md"
           :class="inputColor"
    >
    <p v-if="errors[id]" class="mt-2 text-sm text-red-600 error-message">{{ errors[id] }}</p>
    <p v-if="warnings[id]" class="mt-2 text-sm text-yellow-600">{{ warnings[id] }}</p>
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useTenantStore } from "../stores/tenant";

const tenant = useTenantStore();
const props = defineProps({
  cols: {
    type: String,
    default: "sm:col-span-3"
  },
  label: String,
  id: String,
  placeholder: String,
  disabled: Boolean,
});

const modelValue = computed({
  get: () => tenant.formValues[props.id] || '',
  set: (value) => tenant.setFormValue(props.id, value)
});

const inputColor = computed(() => {
  return modelValue.value ? 'text-gray-700' : 'text-gray-400';
});

const errors = computed(() => tenant.errors);
const warnings = computed(() => tenant.warnings);

watch(modelValue, async (newValue) => {
  await tenant.validateField(props.id, newValue);
});

</script>
